import React from "react";
import { useTranslation } from "react-i18next";

const AddressTypeSelector = (props:any) => {

  const options = ["Home", "Office", "Other"];
  const {t} = useTranslation();

  return (
    <div className="flex flex-col items-start space-y-2">
      <label className="text-base font-normal">
        {t("MyAddress.selectAddressType")}
      </label>
      <div className="flex space-x-2">
        {options.map((option) => (
          <label key={option} className={`cursor-pointer px-6 py-2 rounded-full textMd font-normal border bg-[#F3F3F3] text-black ${ props?.addressType === option? " border-black ": " border-[#F3F3F3] "}`} >
            <input
              type="radio"
              name="addressType"
              value={option}
              className="hidden"
              checked={props?.addressType === option}
              onChange={() => props?.handleSelectAddressType(option)}
            />
            {option}
          </label>
        ))}
      </div>
    </div>
  );
};

export default AddressTypeSelector;
